import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Paper, Grid, Typography, TableContainer, Container, } from '@mui/material';
import { getRandomStr, roundNum } from '../../../../helpers';
import PerformanceBar from './PerformanceBar';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& .Item-Head': {
    background: '#fbfbfc',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(1.5, 2, 1.5, 2),
    borderRadius: '7px 7px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '1rem !important',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(1),
  }
}));

const Performance = ({ fund_metrics, col6, name }) => {
  const { perf: perfChart, txtBlock } = fund_metrics || {}

  let description;
  try { description = JSON.parse(txtBlock) } catch (error) { description = "" }
  description = description && description.length > 0 ? description.find(d => d.section === "performance") : ""

  let sp500vsPerf;
  try { sp500vsPerf = JSON.parse(txtBlock) } catch (error) { sp500vsPerf = "" }
  sp500vsPerf = sp500vsPerf && sp500vsPerf.length > 0 ? sp500vsPerf.find(d => d.section === "sp500perf") : ""

  return (
    <>
      {perfChart && perfChart !== "" ?
        <Grid key={getRandomStr(3)} size={{ xs: 12, md: col6 ? 6 : 4 }}>
          <Item component="div" className="py-2" sx={{ display: 'flex', flexDirection: "column", justifyContent: 'start', }}>
            <Box component="div" className="option-title my-1 py-0">
              <Typography
                className="Item-Head"
                variant="h3"
                sx={{
                  color: '#333',
                  fontWeight: 700,
                  fontSize: '1rem',
                  // borderBottom: '0 !important',
                  // my: 1.4,
                  pb: '1rem !important',
                }}
              >
                {`XXXXX Annual Return Estimates Vs S&P 500`.replace(/XXXXX/g, name)}
              </Typography>
            </Box>
            <Box component="div" sx={{ pt: 2, '& svg': { height: '-webkit-fill-available !important', }, }}>
              <Box component="div" className="option-content" sx={{ px: 2 }}>
                <Typography variant="p" sx={{ fontSize: '.9rem', }} dangerouslySetInnerHTML={{ __html: description && description.text ? description.text : "" }} />
              </Box>
              <PerformanceBar
                data={perfChart}
                category={'Performance'}
                value={"performance"}
                sp500vsPerf={sp500vsPerf && sp500vsPerf?.text ? sp500vsPerf.text : null}
              />
            </Box>
          </Item>
        </Grid> : null}
    </>
  );
}
export default Performance
